export const stripe = {
  subTitle:
    "Collega il tuo account Stripe per addebitare ai tuoi clienti le prenotazioni in modo rapido e semplice, evitando le commissioni delle agenzie di viaggio online.",
};
